'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languageText = exports.languagesText = exports.getColorText = exports.colors = exports.whiteText = exports.greenText = exports.blueText = exports.yellowText = exports.redText = exports.colorText = exports.themeText = exports.generalText = exports.nameText = exports.invalidValueText = exports.invalidFormatText = exports.saveText = exports.submitText = exports.cancelText = exports.allPluralText = exports.allText = exports.getLanguageText = exports.languages = exports.getFormatting = exports.getAvailableLanguages = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAvailableLanguages = exports.getAvailableLanguages = function getAvailableLanguages(translations) {
  return Object.keys(translations);
};

var linesToParagraphs = function linesToParagraphs() {
  for (var _len = arguments.length, paragraphs = Array(_len), _key = 0; _key < _len; _key++) {
    paragraphs[_key] = arguments[_key];
  }

  return _react2.default.createElement(
    'div',
    null,
    paragraphs.map(function (node) {
      return typeof node === 'string' ? node.split('\n').map(function (text) {
        return text ? _react2.default.createElement(
          'p',
          null,
          text
        ) : _react2.default.createElement('br', null);
      }) : node;
    }).reduce(function (nodes, node) {
      return nodes.concat(node);
    }, [])
  );
};

var getFormatting = exports.getFormatting = function getFormatting(defaultMessage) {
  return defaultMessage.indexOf('\n') > -1 ? linesToParagraphs : null;
};

var languages = exports.languages = {
  en: _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'EN',
    description: 'English text',
    defaultMessage: 'English'
  }),
  it: _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'IT',
    description: 'Italian text',
    defaultMessage: 'Italian'
  })
};

var getLanguageText = exports.getLanguageText = function getLanguageText(language) {
  return languages[language];
};

var allText = exports.allText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ALL',
  description: 'All text (singular for other languages)',
  defaultMessage: 'All'
});

var allPluralText = exports.allPluralText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ALL_PLURAL',
  description: 'All text (plural for other languages)',
  defaultMessage: 'All'
});

var cancelText = exports.cancelText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'CANCEL',
  description: 'Cancel button text',
  defaultMessage: 'Cancel'
});

var submitText = exports.submitText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SUBMIT',
  description: 'Submit button text',
  defaultMessage: 'Submit'
});

var saveText = exports.saveText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SAVE',
  description: 'Save button text',
  defaultMessage: 'Save'
});

var invalidFormatText = exports.invalidFormatText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'INVALID_FORMAT',
  description: 'Error to notify invalid format',
  defaultMessage: 'Invalid format'
});

var invalidValueText = exports.invalidValueText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'INVALID_VALUE',
  description: 'Error to notify invalid value',
  defaultMessage: 'Invalid value'
});

var nameText = exports.nameText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'NAME',
  description: 'Name',
  defaultMessage: 'Name'
});

var generalText = exports.generalText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'GENERAL',
  description: 'Indicate general section',
  defaultMessage: 'General'
});

var themeText = exports.themeText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'THEME',
  description: 'Theme text',
  defaultMessage: 'Theme'
});

var colorText = exports.colorText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'COLOR',
  description: 'Color title',
  defaultMessage: 'Color'
});

var redText = exports.redText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'RED',
  description: 'Red color',
  defaultMessage: 'Red'
});

var yellowText = exports.yellowText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'YELLOW',
  description: 'Yellow title',
  defaultMessage: 'Yellow'
});

var blueText = exports.blueText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'BLUE',
  description: 'Blue title',
  defaultMessage: 'Blue'
});

var greenText = exports.greenText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'GREEN',
  description: 'Green title',
  defaultMessage: 'Green'
});

var whiteText = exports.whiteText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'WHITE',
  description: 'White title',
  defaultMessage: 'White'
});

var colors = exports.colors = {
  red: redText,
  yellow: yellowText,
  blue: blueText,
  green: greenText,
  white: whiteText
};

var getColorText = exports.getColorText = function getColorText(color) {
  return colors[color];
};

var languagesText = exports.languagesText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'LANGUAGES',
  description: 'Languages title',
  defaultMessage: 'Languages'
});

var languageText = exports.languageText = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'LANGUAGE',
  description: 'Language title',
  defaultMessage: 'Language'
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/util/i18n.js
 ** module id = 52
 ** module chunks = 0
 **/